import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch, } from 'vue-property-decorator';
import languages from './locale/index';
// @ts-ignore
import cloneDeep from 'lodash/cloneDeep';
import { Icon, Button, Modal, Select, Checkbox, Avatar, } from '@h3/antd-vue';
import { StaticUtils } from '@cloudpivot/form/utils/utils';
let SmartOrg = class SmartOrg extends Vue {
    constructor() {
        // prop接口
        super(...arguments);
        this.visible = false;
        this.searchKey = '';
        this.checkAll = false;
        this.language = languages;
        this.breadcrumbList = [];
        this.selectedList = [];
        this.orgTreeList = [];
        this.currentPageOrg = [];
        this.searchList = [];
        this.isSearching = false;
        this.hover = false;
        this.showNosearchInfo = false;
        this.visiblePart = false; //显示精简列表
        // 搜索分页
        this.page = 0;
        this.size = 50;
    }
    mounted() {
        this.currentPageOrg = this.deepClone(this.org);
        this.selectedList = this.deepClone(this.selectedData);
        this.initSelectItem(this.currentPageTarget);
        this.visiblePart = false;
        this.handleShowPartData();
    }
    get t() {
        return languages[this.locale];
    }
    get hasValue() {
        return this.selectedData && this.selectedData.length > 0;
    }
    get selectValue() {
        return this.selectedData;
    }
    set selectValue(val) {
        this.$emit('change', val);
    }
    get indeterminate() {
        const hasSelectItem = this.currentPageTarget.filter((i) => i.isSelected) || [];
        return (hasSelectItem.length > 0 &&
            hasSelectItem.length < this.currentPageTarget.length);
    }
    get selectedOrgNum() {
        return this.countNumber(this.selectedList, 'org');
    }
    get selectedUserNum() {
        return this.countNumber(this.selectedList, 'user');
    }
    get searchOrgNum() {
        if (this.departmentsTotal > 0) {
            return this.departmentsTotal > 999
                ? `${this.departmentsTotal / 10000}万`
                : this.departmentsTotal;
        }
        else {
            return this.countNumber(this.searchList, 'org');
        }
    }
    get searchUserNum() {
        if (this.usersTotal > 0) {
            return this.usersTotal > 999
                ? `${this.usersTotal / 10000}万`
                : this.usersTotal;
        }
        else {
            return this.countNumber(this.searchList, 'user');
        }
    }
    get defaultTitle() {
        return this.selectUser
            ? this.selectOrg
                ? this.t.UserAndOrg
                : this.t.SelectUser
            : this.t.SelectOrg;
    }
    get currentPageUsers() {
        return this.currentPageOrg.filter((i) => i.type === 'user');
    }
    get currentPageDepartment() {
        return this.currentPageOrg.filter((i) => i.type === 'org');
    }
    get currentPageTarget() {
        if (this.selectUser && !this.selectOrg) {
            return this.currentPageUsers;
        }
        else if (!this.selectUser && this.selectOrg) {
            return this.currentPageDepartment;
        }
        else if (this.selectUser && this.selectOrg) {
            return this.currentPageOrg;
        }
        return [];
    }
    get selectText() {
        let text = '';
        if (this.selectOrg) {
            text = `${this.selectedOrgNum} ${this.t.Orgs}`;
        }
        if (this.selectUser) {
            if (text.length > 0) {
                text += ', ';
            }
            text += `${this.selectedUserNum} ${this.t.Users}`;
        }
        return text;
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem('token');
    }
    //是否显示全选框，若当前页没有可选数据，则隐藏
    get showCheckAll() {
        const checkboxList = this.currentPageOrg.filter((item) => (item.type === 'org' && this.selectOrg) ||
            (item.type === 'user' && this.selectUser));
        return !!checkboxList.length;
    }
    getDownloadUrl(refId) {
        let url = `${this.apiHost}/api/aliyun/download?refId=${refId}`;
        if (this.token) {
            url += '&access_token=' + this.token;
        }
        return url;
    }
    // 总条数
    get total() {
        if (this.selectUser && this.selectOrg) {
            return this.departmentsTotal + this.usersTotal;
        }
        else {
            if (this.selectUser) {
                return this.usersTotal;
            }
            if (this.selectOrg) {
                return this.departmentsTotal;
            }
        }
        return '0';
    }
    // 点击人员搜索结果外的空白区域隐藏浮层
    hidePanel(event) {
        var sp = document.getElementById('myPanel');
        if (sp) {
            if (!sp.contains(event.target)) {
                this.searchList = [];
                this.isSearching = false;
            }
        }
    }
    //调用精简显示操作函数
    handleShowPartData() {
        if (this.showPart) {
            this.$nextTick(() => {
                if (this.selectedList.length > 1) {
                    this.visiblePart = true;
                }
                else {
                    this.visiblePart = false;
                }
            });
        }
        else {
            this.visiblePart = false;
        }
    }
    onlocaleChange() {
        console.log('999===>', this.locale);
    }
    onselectValueChange() {
        this.handleShowPartData();
    }
    onShowPartChange() {
        this.handleShowPartData();
    }
    /**
     * 清楚操作
     */
    clear() {
        // this.selectValue = [];
        // this.selectedList = [];
        this.visiblePart = false;
        this.selectValue = [];
        // this.$emit('change', this.selectValue);
    }
    clearInput() {
        this.searchKey = '';
    }
    checkExist(id) {
        const { keepDeptIds } = this;
        return keepDeptIds.includes(id);
    }
    deleteItem(item) {
        if (this.disabled) {
            return;
        }
        const isExist = this.checkExist(item.id);
        if (isExist)
            return;
        this.visiblePart = false;
        this.selectValue = this.selectValue.filter((res) => {
            return res.key !== item.key;
        });
        this.handleShowPartData();
        // this.$emit('change', this.selectValue);
        // debugger
    }
    // 工具函数
    deepClone(obj) {
        // const objClone: any = Array.isArray(obj) ? [] : {};
        // if (obj && typeof obj === 'object') {
        //   for (const key in obj) {
        //     if (obj.hasOwnProperty(key)) {
        //       if (obj[key] && typeof obj[key] === 'object') {
        //         objClone[key] = this.deepClone(obj[key]);
        //       } else {
        //         objClone[key] = obj[key];
        //       }
        //     }
        //   }
        // }
        // return objClone;
        return cloneDeep(obj);
    }
    filterSelect(pushObj, targetObj = this.selectedList) {
        return pushObj.filter((pushItem) => {
            if (this.isExport) {
                return (!targetObj.some((item) => item.key === pushItem.key) &&
                    pushItem.hasPermission);
            }
            else {
                return !targetObj.some((item) => item.key === pushItem.key);
            }
        });
    }
    setSelectList(targetObj, push = true) {
        if (push) {
            const pushItem = this.filterSelect(this.deepClone(targetObj));
            this.selectedList = [...this.selectedList, ...pushItem];
        }
        else {
            targetObj.forEach((item) => {
                this.delectItem(item, this.selectedList);
            });
        }
        targetObj.forEach((i) => (i.isSelected = push));
    }
    setSingleItem(item) {
        this.selectedList.every((i) => (i.isSelected = false));
        this.onDeselect(this.currentPageTarget.find((o) => !!o.isSelected && o.key !== item.key));
        this.selectedList = [item];
    }
    delectItem(item, list = [], length = 1, above = false) {
        if (list.length === 0)
            return;
        const index = list.findIndex((i) => i.key === item.key);
        const end = list.length - index;
        if (above) {
            list.splice(index + 1, end);
        }
        else {
            list.splice(index, length);
        }
    }
    countNumber(targetList = [], type) {
        const num = targetList.filter((i) => i.type === type).length;
        if (num > 999) {
            return `${num / 10000}万`;
        }
        return num;
    }
    initSelectItem(targetList = []) {
        targetList.forEach((i) => {
            const selected = this.selectedList.some((o) => o.key === i.key);
            if (selected) {
                this.$set(i, 'isSelected', true);
            }
            else {
                this.$set(i, 'isSelected', false);
            }
        });
    }
    // 销毁时重置搜索
    distory() {
        this.isSearching = false;
        this.searchKey = '';
        this.searchList = [];
    }
    // Dom操作绑定函数
    focus() {
        if (this.disabled) {
            return;
        }
        this.$emit('focus', this.orgName);
        // this.$emit('focus', this.$refs.select);
        this.visible = true;
        // eslint-disable-next-line
        // (this.$refs.select as any).blur();
    }
    // test() {
    //   debugger
    //   this.visible = true;
    // }
    //删除已选中的目标时同时更新搜索和当前页的list
    onDeselect(value) {
        if (!value)
            return;
        const deselectItem = this.currentPageTarget.find((o) => value.key === o.key);
        const deselectItemSearch = this.searchList.find((o) => value.key === o.key);
        if (deselectItem) {
            deselectItem.isSelected = false;
        }
        if (deselectItemSearch) {
            deselectItemSearch.isSelected = false;
        }
    }
    onCheckAllChange(value) {
        this.checkAll = value.target.checked;
        if (this.checkAll) {
            this.setSelectList(this.currentPageTarget);
        }
        else {
            this.setSelectList(this.currentPageTarget, false);
        }
    }
    onSelecte(item, val) {
        if (item.isSelected) {
            this.$set(item, 'isSelected', false);
            this.delectItem(item, this.selectedList);
        }
        else {
            if (this.isMulpitle) {
                this.selectedList.push(item);
            }
            else {
                this.searchList.forEach((x) => (x.isSelected = false));
                this.setSingleItem(item);
            }
            this.$set(item, 'isSelected', true);
        }
        this.checkAll = this.currentPageTarget.every((i) => i.isSelected);
    }
    onDelectItem(item) {
        const isExist = this.checkExist(item.id);
        if (isExist)
            return;
        this.delectItem(item, this.selectedList);
        this.onDeselect(item);
        this.checkAll = this.currentPageTarget.every((i) => i.isSelected);
    }
    // 接口事件
    // @Emit('searchFocus')
    searchFocus(val) {
        // return val;
        this.$emit('searchFocus', val);
    }
    // @Emit('searchChange')
    // searchChange(val: any) {
    //   if (this.searchKey === '') {
    //     this.searchList = [];
    //   }
    //   this.$emit('searchChange', this.searchKey);
    //   // return this.searchKey;
    // }
    // @Emit('onSearch')
    onSearch() {
        StaticUtils.debound(() => {
            clearTimeout(this.searchTaskRef);
            if (this.searchKey === '') {
                this.searchList = [];
                return;
            }
            if (this.showLoading)
                return;
            this.searchTaskRef = setTimeout(() => {
                this.isSearching = true;
                this.$emit('onSearch', this.searchKey);
            }, 500);
        }, 1000);
        // return this.searchKey;
    }
    // @Emit('searchBlur')
    // searchBlur(val: any) {
    //   // this.isSearching = false;
    //   return val;
    // }
    // @Emit('cancle')
    onClickCancle() {
        this.breadcrumbList = [];
        this.visible = false;
        this.distory();
        this.selectedList = this.deepClone(this.selectedData);
        this.initSelectItem(this.currentPageTarget);
        this.$emit('cancle');
    }
    // @Emit('ok')
    ok() {
        this.breadcrumbList = [];
        this.visible = false;
        this.distory();
        this.$emit('ok', this.selectedList);
        this.visiblePart = false;
        this.handleShowPartData();
        // return this.selectedList;
    }
    // @Emit('onClickTrunBack')
    onClickTrunBack() {
        this.breadcrumbList = [];
        this.$emit('onClickTrunBack');
    }
    // @Emit('onClickBreadcrumb')
    onClickBreadcrumb(item) {
        if (this.isDisableClick === true) {
            this.$message.warning(this.t.WaitUntilDataReturn);
            return;
        }
        this.delectItem(item, this.breadcrumbList, this.breadcrumbList.length, true);
        this.$emit('onClickBreadcrumb', item);
        return item;
    }
    // @Emit('onOrgTreeScroll')
    onScrollChanged(val) {
        this.$emit('onOrgTreeScroll');
    }
    // @Emit('onSearchListScroll')
    onScrollSearch(e) {
        this.$emit('onSearchListScroll');
    }
    // @Emit('onClickNextHierarchy')
    onClickNextHierarchy(val) {
        // debugger
        // debugger
        // this.t
        if (this.isDisableClick === true) {
            this.$message.warning(this.t.WaitUntilDataReturn);
            return;
        }
        if (val.isLeaf && this.selectOrg && !this.selectUser)
            return;
        // console.log('rrrrrr',val)
        // 如果设置允许递归则展示
        if (!this.allowRecursion && val.isSelected)
            return;
        if (this.breadcrumbList.length > 0) {
            const last = this.breadcrumbList[this.breadcrumbList.length - 1];
            if (last.key === val.key) {
                return;
            }
        }
        this.breadcrumbList.push(val);
        this.$emit('onClickNextHierarchy', val);
        // return val;
    }
    onOrgChanged(val, oldVal) {
        this.currentPageOrg = this.deepClone(val);
        this.initSelectItem(this.currentPageTarget);
    }
    onSearchListChanged(val, oldVal) {
        this.searchList = this.deepClone(val);
        if (this.searchList.length === 0) {
            this.showNosearchInfo = true;
        }
        else {
            this.showNosearchInfo = false;
        }
        // 在改变之前筛选已经被选中的元素 设置isSelecte
        this.initSelectItem(this.searchList);
    }
    initSelectedList(val, oldVal) {
        this.selectedList = this.deepClone(val);
    }
    changeModelStatus(val, oldVal) {
        this.visible = val;
        if (val) {
            this.focus();
        }
    }
    selectAll(val, oldVal) {
        let isSelectAll = false;
        let temData = [];
        // 解决 添加子管理员时，部门列表为空时，也全选上的问题（负责人：周龙秋）20200515
        // 解决全选问题 （负责人：郑传强）20200602
        if (val.length) {
            const { selectOrg, selectUser } = this;
            if (selectOrg && !selectUser) {
                // 只选组织org
                temData = val.filter((v) => v.type === 'org');
            }
            else if (!selectOrg && selectUser) {
                // 只选人 user
                temData = val.filter((v) => v.type === 'user');
            }
            else {
                // 两者均选
                temData = val;
            }
            isSelectAll = temData.every((item) => item.isSelected);
        }
        if (temData.length <= 0) {
            isSelectAll = false;
        }
        this.checkAll = isSelectAll;
    }
    clearSearchKey(val, oldVal) {
        if (val === '')
            this.distory();
    }
};
tslib_1.__decorate([
    Prop()
], SmartOrg.prototype, "prefixCls", void 0);
tslib_1.__decorate([
    Prop()
], SmartOrg.prototype, "prefixStyle", void 0);
tslib_1.__decorate([
    Prop()
], SmartOrg.prototype, "selectStyle", void 0);
tslib_1.__decorate([
    Prop()
], SmartOrg.prototype, "showNotData", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartOrg.prototype, "showSelect", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], SmartOrg.prototype, "showError", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], SmartOrg.prototype, "showModel", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], SmartOrg.prototype, "isExport", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], SmartOrg.prototype, "isDisplayRoot", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], SmartOrg.prototype, "showPart", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: '',
    })
], SmartOrg.prototype, "title", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: '',
    })
], SmartOrg.prototype, "placeholder", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: '',
    })
], SmartOrg.prototype, "orgName", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: '',
    })
], SmartOrg.prototype, "selectPlaceholder", void 0);
tslib_1.__decorate([
    Prop({
        type: Array,
        default: [],
    })
], SmartOrg.prototype, "org", void 0);
tslib_1.__decorate([
    Prop({
        type: Array,
        default: [],
    })
], SmartOrg.prototype, "searchData", void 0);
tslib_1.__decorate([
    Prop({
        type: Array,
        default: [],
    })
], SmartOrg.prototype, "selectedData", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: 'zh',
    })
], SmartOrg.prototype, "locale", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartOrg.prototype, "isMulpitle", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartOrg.prototype, "selectUser", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartOrg.prototype, "selectOrg", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartOrg.prototype, "allowRecursion", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], SmartOrg.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], SmartOrg.prototype, "keepDeptIds", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], SmartOrg.prototype, "showLoading", void 0);
tslib_1.__decorate([
    Prop({
        default: true,
    })
], SmartOrg.prototype, "isDisableClick", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], SmartOrg.prototype, "departmentsTotal", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], SmartOrg.prototype, "usersTotal", void 0);
tslib_1.__decorate([
    Watch('locale')
], SmartOrg.prototype, "onlocaleChange", null);
tslib_1.__decorate([
    Watch('selectValue')
], SmartOrg.prototype, "onselectValueChange", null);
tslib_1.__decorate([
    Watch('showPart')
], SmartOrg.prototype, "onShowPartChange", null);
tslib_1.__decorate([
    Watch('org')
], SmartOrg.prototype, "onOrgChanged", null);
tslib_1.__decorate([
    Watch('searchData')
], SmartOrg.prototype, "onSearchListChanged", null);
tslib_1.__decorate([
    Watch('selectedData')
], SmartOrg.prototype, "initSelectedList", null);
tslib_1.__decorate([
    Watch('showModel')
], SmartOrg.prototype, "changeModelStatus", null);
tslib_1.__decorate([
    Watch('currentPageOrg')
], SmartOrg.prototype, "selectAll", null);
tslib_1.__decorate([
    Watch('searchKey')
], SmartOrg.prototype, "clearSearchKey", null);
SmartOrg = tslib_1.__decorate([
    Component({
        name: 'SmartOrg',
        components: {
            AAvatar: Avatar,
            AIcon: Icon,
            AButton: Button,
            AModal: Modal,
            ASelect: Select,
            ASelectOption: Select.Option,
            ACheckbox: Checkbox,
        },
    })
], SmartOrg);
export default SmartOrg;
